import { saveToStore } from 'redux/features/user/userSlice';

export const show = (dispatch, message, options) => {
  options?.duration &&
    dispatch(saveToStore(['toastDuration', options?.duration]));
  options?.type && dispatch(saveToStore(['toastType', options?.type]));
  dispatch(saveToStore(['toastMessage', message]));
};

export const hide = (dispatch) => {
  dispatch(saveToStore(['toastMessage', null]));
};

const toast = [show, hide];

export default toast;
